var slider = {
	// variable: 'value' .... can get sile this self.variable
	vars: {
		homepage: '.homepageHero__carousel-container',
		detailGallery: '.coworkProfile__mainGallery-container',
		coworkPlans: '.coworkPlans-container',
		arrow:
			'<svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.18539 15.5018C7.48511 15.812 7.98393 15.812 8.29413 15.5018C8.59384 15.2021 8.59384 14.7033 8.29413 14.4043L2.67222 8.78235L21.2238 8.78236C21.6562 8.78166 21.9999 8.43793 21.9999 8.00547C21.9999 7.57302 21.6562 7.21811 21.2238 7.21811L2.67222 7.21811L8.29413 1.60668C8.59384 1.29649 8.59384 0.796963 8.29413 0.497948C7.98393 0.187754 7.48441 0.187754 7.1854 0.497948L0.232585 7.45076C-0.0776093 7.75047 -0.0776094 8.2493 0.232585 8.54831L7.18539 15.5018Z" fill="white"/></svg>',
	},
	init: function () {
		var self = this;

		if (document.querySelector(self.vars.homepage)) {
			this.homepageSlider();
		}

		if (document.querySelector(self.vars.detailGallery)) {
			this.detailGallery();
		}

		if (document.querySelector(self.vars.coworkPlans)) {
			this.coworkPlans();
		}
	},
	detailGallery: function () {
		var self = this;

		var slider = tns({
			container: self.vars.detailGallery,
			items: 1,
			slideBy: 1,
			swipeAngle: false,
			speed: 1250,
			gutter: 24,
			nav: false,
			controlsText: [self.vars.arrow, self.vars.arrow],
			mouseDrag: true,
		});
	},
	homepageSlider: function () {
		var self = this;

		var slider = tns({
			container: self.vars.homepage,
			items: 3,
			slideBy: 1,
			swipeAngle: false,
			speed: 400,
			nav: false,
			controlsText: [self.vars.arrow, self.vars.arrow],
			mouseDrag: true,
			responsive: {
				0: {
					fixedWidth: 250,
					gutter: 16,
				},
				500: {
					fixedWidth: 350,
					gutter: 24,
				},
			},
		});
	},
	coworkPlans: function () {
		var self = this;

		var slider = tns({
			container: self.vars.coworkPlans,
			items: 3,
			slideBy: 1,
			fixedWidth: 240,
			swipeAngle: false,
			speed: 400,
			gutter: 24,
			nav: false,
			controlsText: [self.vars.arrow, self.vars.arrow],
			loop: false,
			mouseDrag: true,
		});
	},
};

export { slider };
